import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Navigation } from './components/navigation/Navigation';
import { PuzzlePage } from './components/puzzlePage/PuzzlePage';
import { PlayPage } from './components/playPage/PlayPage';
import './App.css';

function App() {
    return (
        <Router>
            <Navigation />
            <Routes>
                <Route path="/" element={<PlayPage />} />
                <Route path="/puzzle" element={<PuzzlePage />} />
            </Routes>
        </Router>
    );
}

export default App;
